export const SOCIAL_TRADING_RATINGS_URL =
  "https://socialtradingleaderboard.upforex.com/widgets/ratings?widgetKey=social_platform_ratings";
/** PAAM ratings URL — update when backend provides the PAAM-specific widget key. */
export const PAAM_RATINGS_URL =
  "http://176.126.66.149:8081/widgets/ratings?widgetKey=social_platform_ratings";
